import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { useShop } from '@/components/providers/shop-provider'
import { convert, formatMoney } from '@/lib/shop/money'

interface PriceProps {
    zar: number
    className?: string
}

/** Shows a rand amount in the visitor's chosen currency. */
export const Price = ({ zar, className }: PriceProps): ReactNode => {
    const { currency, rates } = useShop()
    const converted = convert(zar, currency, rates)

    return (
        <span className={cn('tabular-nums', className)}>
            {formatMoney(converted.amount, converted.currency)}
        </span>
    )
}

export const usePrice = () => {
    const { currency, rates } = useShop()

    return (zar: number) => {
        const converted = convert(zar, currency, rates)

        return formatMoney(converted.amount, converted.currency)
    }
}
